import { useEffect, useState } from "react";

import { useApi } from "@backstage/core-plugin-api";
import { githubApiRef } from "@internal/backstage-plugin-github-react";
import { getDataOrThrow } from "@internal/backstage-plugin-utility-common";

/**
 * Fetches the list of environment app names from GitHub.
 *
 * @returns An object containing the `apps` list and a `loading` flag.
 */
export function useEnvironmentApps(): { apps: string[]; loading: boolean } {
    const client = useApi(githubApiRef);
    const [apps, setApps] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const run = async () => {
            try {
                const contents = getDataOrThrow(
                    await client.repo.getContents(
                        "banno",
                        "environments",
                        "shared/kubernetes"
                    )
                );
                setApps(
                    contents
                        .filter(item => item.type === "dir")
                        .map(item => item.name)
                );
            } catch (err) {
                // TODO: surface an error state so the UI can render an explicit empty-state message
                console.error(
                    "useEnvironmentApps: failed to fetch environment apps from GitHub",
                    err
                );
            } finally {
                setLoading(false);
            }
        };
        run();
    }, [client]);

    return { apps, loading };
}
